export default "__VITE_ASSET__ZXFiZhS9__"